<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title--Front-Matter-" lang="en-US">The Grand Duchess of Nowhere</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US">Laurie Graham</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US"><img alt="ORIM logo" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?578794dc